import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LinksService } from '@core/services/links/links.service';
import { AppSettingsService } from '@core/services/settings/settings.service';
import { environment } from '@environments/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { PbdsFooterHeightDirective } from '@pb-design-system/pb-design-system/utils';
import { ModalService } from '@shared/services/modal.service';
import packageContent from '../../../../../package.json';
import { BaseComponent } from '../base-component';
import { LicenceAttributionComponent } from '../license-attribution/license-attribution.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  hostDirectives: [{ directive: PbdsFooterHeightDirective }],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent extends BaseComponent {
  private readonly modalService = inject(ModalService);
  private readonly appSettingsService = inject(AppSettingsService);
  protected readonly linksService = inject(LinksService);
  private readonly startYear = 2019;

  protected get date() {
    const currentYear: number = new Date().getFullYear();
    return this.startYear === currentYear ? `${currentYear}` : `${this.startYear}-${currentYear}`;
  }

  protected get version() {
    const buildDate = this.appSettingsService.settings().buildDate;
    return `${packageContent.version} - ${environment.env_prefix}-${buildDate.replace(/[-:ZT.]/gi, '')}`;
  }

  protected openLicenceModal() {
    this.modalService.open(LicenceAttributionComponent, {
      closeOnBackdropClick: true,
      size: 'lg',
      customClass: 'no-class',
    });
  }
}
